(ns com.theplantscape.web-ui.tailwind.not-found
  (:require [com.theplantscape.web-ui.tailwind.images :refer [picture]]))

(defn ui-missing [{:keys [title path description] :or
                   {title "Sorry page does not exist, or is currently unavailable."
                    description [:p.mt-4  "This has been logged, but you may report it "
                                 [:a.link {:href "https://matrix.to/#/#theplantscape.com:matrix.org"} "here"]]}}]
  [:div.tps-secondary.rounded-3xl.background-blue-200
   [:div.flex
    [picture {:image "https://img.theplantscape.com/api/image/do/404-image-01.jpg?p=h-192"}]
    [:div.ml-4 {:class "w-2/3"}
     [:h1.text-3xl title]
     (when path
       [:p.mt-4 (str path)])
     description]]])
